import React from 'react';
import { ColumnDef } from '@tanstack/react-table';
import { Tags, Typography } from '@wisecare-tech/design-system-web';
import { iListSacRequest } from 'domain/usecases/sacRequest/remote';
import { formatISODateHour } from 'utils/tableDateHour';
import Translator from '~/presentation/components/i18n/Translator';
import { Information } from '../styles';

export const finalizedColumns: ColumnDef<iListSacRequest>[] = [
  {
    accessorKey: 'id',
    header: 'ID',
    cell: ({ row }) => {
      const data = row.getValue('id') as iListSacRequest['id'];

      return <div>{data}</div>;
    },
  },
  {
    accessorKey: 'created',
    header: Translator('Solicitado em'),
    cell: ({ row }) => {
      const data = row.getValue('created') as iListSacRequest['created'];

      const dateHour = formatISODateHour(data);

      return (
        <Information>
          <Typography variant="b4_14regular">{dateHour.date}</Typography>
          <Typography variant="b4_14regular" style={{ color: '#656A6E' }}>
            {dateHour.hour}
          </Typography>
        </Information>
      );
    },
  },
  {
    accessorFn: row => row,
    header: Translator('Solicitante'),
    cell: ({ cell }) => {
      const data = cell.getValue() as iListSacRequest;

      return (
        <Information>
          <Typography variant="b4_14regular">{data?.name ?? ''}</Typography>
          <Typography variant="b4_14regular" style={{ color: '#656A6E' }}>
            {data?.phone ?? ''}
          </Typography>
        </Information>
      );
    },
  },
  {
    accessorFn: row => row,
    header: Translator('Contato'),
    cell: ({ cell }) => {
      const data = cell.getValue() as iListSacRequest;

      return (
        <Information>
          <Typography variant="b4_14regular">{data?.phone}</Typography>
          <Typography variant="b4_14regular" style={{ color: '#656A6E' }}>
            {data?.email}
          </Typography>
        </Information>
      );
    },
  },
  {
    accessorKey: 'outcome',
    header: 'Status',
    cell: ({ row }) => {
      const data = row.getValue('outcome') as iListSacRequest['outcome'];

      const mapStatusColor: Record<string, string> = {
        RESOLVED: 'green',
        TRANSFERED: 'blue',
        UNRESOLVED: 'red',
        INTERRUPTED: 'white',
        undefined: 'white',
      };

      const mapStatusText: Record<string, string> = {
        RESOLVED: 'Resolvido',
        TRANSFERED: 'Transferido',
        UNRESOLVED: 'Não resolvido',
        INTERRUPTED: 'Interrompido',
        undefined: 'Interrompido',
      };

      return data ? (
        <Tags
          text={mapStatusText[data]}
          variant={mapStatusColor[data] as any}
        />
      ) : (
        '-'
      );
    },
  },
];
